import React from 'react';
import Layout from '../components/Layout/Layout';
import BookingImg from '../assets/img/booking.jpeg';
import SEO from '../components/SEO/seo';
import { ContactForm } from '../components/ContactForm/ContactForm';

export default function BookingPage() {
  return (
    <Layout paralaxImg={BookingImg} heading='Ready, steady, clean!'>
      <SEO
        title='Booking | Cleaning Service | Deelightful Cleaning'
        description='Book a Deelightful cleaning service today. We will provide a fantastic, professional and skilled maid to make your home shine!'
      />
      <ContactForm />
    </Layout>
  );
}
